export const createContentSearchRequest = (params) => {
  return {
    url: '/content_search?query=' + params.query + '&page=' + params.page + '&per_page=' + params.per_page + '&date_from=' + params.date_from + '&date_to=' + params.date_to + '&min_engagement=' + params.minEngagement,
    method: 'GET',
  };
};
